import { redirectToLoginPage } from "../api/login-service";
import * as http from "../network/TutorHttp";
import { DESC_ANSWER, DOUBT, getUserName, HTTP_CODES, IMAGE_TO_TEXT } from "../utils/TutorConstants";
import { getItemFromCache } from "../utils/wall/wall-constants";
import Http from "./Http";
import { disconnectSocket, socketInitialisation } from "./SocketOperation";

export const getDefaultHeaders = async () => {
  let headers = {};
  headers["Content-Type"] = "application/json";
  return headers;
};
export const getAdditionalDetails = async () => {
  let res = await getItemFromCache("user_additional_details");
  return res;
};
export const tutorApiService = async (endpoint, options = {}) => {
  let URL = window.ENV.TUTOR_API_URL;
  let headers = { ...(options.headers || {}) };
  let updatedHeaders = await http.getHeaders(headers);
  options = { ...options, headers: updatedHeaders };
  const response = await fetch(URL + endpoint, options);
  return response;
};
export const getChatInfoByIds = async (chatIds) => {
  try {
    let body = {
      ids: chatIds,
      showQuestion: false,
      showSummary: true,
    };
    let URL = "/ai-assist/chat-history/by-ids";
    const res = await http.post(URL, JSON.stringify(body));
    return res?.data || [];
  } catch (e) {
    return [];
  }
};
export const getGpMedia = async (questionID) => {
  try {
    const res = await Http.get("/ai-assist/gp-media?questionId=" + questionID);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};
export const getVideoMetada = async (body, chat_id, chat_index) => {
  try {
    let headers = {
      "x-chat-id": chat_id,
      "x-chat-index": chat_index,
    };
    const res = await Http.post(
      "/ai-assist/video-pull",
      JSON.stringify(body),
      headers
    );
    return res?.data || [];
  } catch (e) {
    return [];
  }
};
export const getImageMetaData = async (body, chat_id, chat_index) => {
  try {
    let headers = {
      "x-chat-id": chat_id,
      "x-chat-index": chat_index,
    };
    const res = await Http.post(
      "/ai-assist/image-pull",
      JSON.stringify(body),
      headers
    );
    return res?.data || [];
  } catch (e) {
    return [];
  }
};
export const practiceConvo = async (
  handleStreaming,
  setIsCompleted,
  setLoader,
  body,
  chat_id,
  chatIndex,
  setLoaderText
) => {
  try {
    console.log("Starting the practice conversation...");
    socketInitialisation();
    let headers = {};
    headers["x-chat-id"] = chat_id;
    headers["x-chat-index"] = chatIndex;

    console.log("Sending request to API...");
    const response = await tutorApiService(
      "/ai-assist/v2/practice-question-conversation",
      {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      }
    );
    console.log("Response received from API:", response.status);

    setLoader(false);

    if (response.status == HTTP_CODES.OK || response.status == HTTP_CODES.CREATED) {
      const reader = response.body.getReader();
      setLoaderText("");
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          setIsCompleted(true);
          disconnectSocket();
          return { success: true, status: response.status };
        }
        if (value instanceof Uint8Array && Array.from(value).includes(4)) {
          return { success: false, status: HTTP_CODES.GAATE_WAY_TIMEOUT };
        } else {
          let newData = new TextDecoder().decode(value);
          handleStreaming(newData);
        }
      }
    } else if (response.status == HTTP_CODES.UNAUTHORIZED) {
      redirectToLoginPage();
    } else if (response.status == HTTP_CODES.GAATE_WAY_TIMEOUT) {
      setIsCompleted(true);
      console.log("504 Gateway Timeout error: Server took too long to respond.");
      return handleError(response.status);
    } else {
      setIsCompleted(true);
      return handleError(response.status);
    }
  } catch (err) {
    console.error("Error during fetch request:", err);
    setIsCompleted(true);
    setLoader(false);
    return { success: false, status: HTTP_CODES.GAATE_WAY_TIMEOUT };
  }
};

const handleError = (statusCode) => {
  disconnectSocket();
  return { success: false, status: statusCode };
};
export const fetchSummary = async () => {
  try {
    const res = await Http.get("/ai-assist/summary");
    return res?.data;
  } catch (e) {
    return [];
  }
};
export const fetchChatHistory = async (chatId) => {
  try {
    const res = await http.get("/ai-assist/chat-history", {
      headers: { "x-chat-id": chatId },
    });
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else if (res.status === 401) {
      // redirectToLoginPage();
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};
export const saveEvent = async (eventName, body) => {
  try {
    let headers = { "x-event-name": eventName };
    const res = await http.post("/ai-assist/event", JSON.stringify(body), {
      headers,
    });
    return res?.data || {};
  } catch (e) {
    return;
  }
};

export const saveConvMedia = async (chatId, body) => {
  try {
    let headers = { "x-chat-id": chatId };
    const res = await http.post(
      "/ai-assist/conversation-media",
      JSON.stringify(body),
      {
        headers,
      }
    );
    return res?.data || {};
  } catch (e) {
    return;
  }
};
export const fetchConvMedia = async (chatId) => {
  try {
    let headers = { "x-chat-id": chatId };
    const res = await http.get("/ai-assist/conversation-media", {
      headers,
    });
    return res?.data || {};
  } catch (e) {
    return [];
  }
};
export const saveFeedback = async (chatId, body, mode = "", curriculumObj) => {
  try {
    let name = getUserName();
    body = { ...body, ...curriculumObj, user_name: name };
    let headers = { "x-chat-id": chatId, "x-mode": mode };
    const res = await http.post("/ai-assist/feedback", body, {
      headers,
    });
    return res?.data || {};
  } catch (e) {
    return [];
  }
};

export const getConvrseScore = async (body, chatId, chatIndex) => {
  try {
    let headers = { "x-chat-id": chatId, "x-chat-index": chatIndex };
    const res = await http.post("/ai-assist/conversation-score", body, {
      headers,
    });
    return res?.data;
  } catch (e) {
    return {};
  }
};

export const fetchFeedbackDropdowns = async (module) => {
  try {
    let headers = {};
    headers["module"] = module;
    const res = await http.get("/ai-assist/feedback-dropdowns", { headers });
    return res?.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};
export const fetchMasterIdMappingTopics = async () => {
  try {
    const res = await Http.get("/ai-assist/masterid-mapping-list");
    return res?.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};
export const handledescriptiveAnswer = async (data, chatID) => {
  try {
    let headers = {};
    headers["x-chat-id"] = chatID;
    const res = await http.post(
      "/ai-assist/v1/descriptive-answer",
      JSON.stringify(data),
      { headers }
    );
    return res;
  } catch (e) {
    console.log(e);
    return [];
  }
};
export const fetchOrUpdateDescBasePrompt = async (body) => {
  try {
    let URL = "/ai-assist/playground/base/descriptive-answer";
    const res = await http.post(URL, JSON.stringify(body));
    return res?.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const fetchOrUpdatePrompts = async (mode, body) => {
  try {
    let URL = "/ai-assist/playground/practice";
    if (mode == DOUBT) {
      URL = "/ai-assist/playground/doubt";
    } else if (mode == DESC_ANSWER) {
      URL = "/ai-assist/playground/descriptive-answer";
    } else if (mode == IMAGE_TO_TEXT) {
      URL = "/ai-assist/playground/image-to-text";
    }
    const res = await http.post(URL, JSON.stringify(body));
    return res?.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};
export const verifyDelimiterCheck = async (body, chat_id, chat_index) => {
  try {
    let headers = {
      "x-chat-id": chat_id,
      "x-chat-index": chat_index,
    };
    let endPoint = `/ai-assist/delimiter-check`;
    const res = await Http.post(endPoint, JSON.stringify(body), headers);
    return res?.data || {};
  } catch (e) {
    return {};
  }
};

export const fechSuggestions = async (body) => {
  try {
    let endPoint = `/ai-assist/auto-suggestion`;
    const res = await Http.post(endPoint, JSON.stringify(body));
    return res?.data || {};
  } catch (e) {
    return {};
  }
};

export const fetchSubtopicListById = async (topicID = "") => {
  topicID = `"${topicID.toString()}"`;
  let param = `[${topicID}]`;
  try {
    const res = await Http.get("/knowledge-cell/subtopics?topicIds=" + param);
    return res?.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const fetchAudioByTextStream = async (body, chatID, chatIndex) => {
  body = { ...body };
  const headers = {
    "Content-Type": "application/json",
    "x-chat-id": chatID,
    "x-chat-index": chatIndex
  }
  const res = await tutorApiService("/ai-assist/stream/text-to-speech",
    { method: "POST", headers, body: JSON.stringify(body) }
  );

  if (res.status == HTTP_CODES.OK || res.status == HTTP_CODES.CREATED) {
    return res.body;
  } else {
    return null;
  }
};


export const fetchAudioByText = async (body, chatID, chatIndex) => {
  const headers = {
    "Content-Type": "application/json",
    "x-chat-id": chatID,
    "x-chat-index": chatIndex
  }
  try {
    const res = await http.post("/ai-assist/text-to-speech", body, { headers });
    return res?.data;
  } catch (e) {
    console.error("Error fetching audio:", e.message);
    return null;
  }
};


export const fetchImageToText = async (chatId, body) => {
  try {
    let headers = {
      "Content-Type": "application/json",
      "x-chat-id": chatId,
    };
    const res = await http.post("/ai-assist/image-to-text", body, { headers });
    return res?.data;
  } catch (e) {
    console.log(e);
    return "";
  }
}

export const saveAsFavorite = async (body) => {
  try {
    let endPoint = `/ai-assist/summary/favorite`;
    const res = await Http.put(endPoint, JSON.stringify(body));
    return res?.data || {};
  } catch (e) {
    return;
  }
}

export const getTopicFeaturesData = async (subjectMasterUuid) => {
  try {
    let endPoint = `/topics?subjectMasterUuid=${subjectMasterUuid}&showTopic=all`;
    const res = await Http.get(endPoint);
    return res
  } catch (e) {
    return {};
  }
}

export const getTTSVoiceByModel = async (topic_id, model_name) => {
  try {
    const body = {
      "type": model_name,
      "topic_id": topic_id
    }
    const res = await Http.post("/ai-assist/voiceid-exists", JSON.stringify(body));
    return res?.data;
  } catch (e) {
    return;
  }
};

export const checkISOCREnabled = async (topicID) => {
  try {
    let endPoint = `/ai-assist/ocr/status?topic_id=${topicID}`;
    const res = await http.get(endPoint);
    return res;
  } catch (e) {
    return {};
  }
}
